// extracted by mini-css-extract-plugin
module.exports = {"container":"S","title":"T","buttonGroup":"U","buttonWrapper":"V","cancelButton":"W","confirmButton":"X","error":"Y"};